import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbb99da4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = { key: 8 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "grey-text"
}
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    class: "product-card ion-text-center product-card-title",
    onClick: $setup.handleClick,
    onTouchend: $setup.handleTouchEnd,
    button: "",
    disabled: $props.winningPercentage == 0
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($props.winningPercentage && $setup.settings.showWinningPercentage == 1)
          ? (_openBlock(), _createBlock(_component_ion_badge, {
              key: 0,
              class: "top-left-badge",
              color: "tertiary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(parseFloat($props.winningPercentage.toFixed(1))) + "% ", 1)
              ]),
              _: 1
            }))
          : ($props.product.coralId)
            ? (_openBlock(), _createBlock(_component_ion_badge, {
                key: 1,
                class: "top-left-badge",
                color: "medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.product.coralId), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
        ($props.product.type == 'Gift')
          ? (_openBlock(), _createBlock(_component_ion_badge, {
              key: 2,
              class: "top-right-badge",
              color: "danger"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t('free')), 1)
              ]),
              _: 1
            }))
          : ($props.product.type == 'Game')
            ? (_openBlock(), _createBlock(_component_ion_badge, {
                key: 3,
                class: "top-right-badge",
                color: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('game')), 1)
                ]),
                _: 1
              }))
            : ($props.product.sellingPrice < $props.product.price)
              ? (_openBlock(), _createBlock(_component_ion_badge, {
                  key: 4,
                  class: "top-right-badge",
                  color: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('sale')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
        ($props.product.status == $setup.PRODUCT_STATUSES.hold && $props.product.reservedBy != $setup.user.id)
          ? (_openBlock(), _createBlock(_component_ion_badge, {
              key: 5,
              class: "bottom-left",
              color: "secondary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t('hold')), 1)
              ]),
              _: 1
            }))
          : ([$setup.PRODUCT_STATUSES.sold,$setup.PRODUCT_STATUSES.pendingPayment].includes($props.product.status))
            ? (_openBlock(), _createBlock(_component_ion_badge, {
                key: 6,
                class: "bottom-left",
                color: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('sold')), 1)
                ]),
                _: 1
              }))
            : ([$setup.PRODUCT_STATUSES.auctionClosed].includes($props.product.status))
              ? (_openBlock(), _createBlock(_component_ion_badge, {
                  key: 7,
                  class: "bottom-left",
                  color: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('auctionClosed')), 1)
                  ]),
                  _: 1
                }))
              : ($props.product.auction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    ($setup.getAuctionTimeStatus($props.product.auction) == 'starting-soon')
                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                          key: 0,
                          class: "bottom-left",
                          color: "tertiary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('auctionStartSoon')), 1)
                          ]),
                          _: 1
                        }))
                      : ($setup.getAuctionTimeStatus($props.product.auction) == 'started')
                        ? (_openBlock(), _createBlock(_component_ion_badge, {
                            key: 1,
                            class: "bottom-left",
                            color: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('inAuction')), 1)
                            ]),
                            _: 1
                          }))
                        : ($setup.getAuctionTimeStatus($props.product.auction) == 'ended')
                          ? (_openBlock(), _createBlock(_component_ion_badge, {
                              key: 2,
                              class: "bottom-left",
                              color: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('auctionClosed')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]))
                : ($setup.cartItems.find(item => item.productId == $props.product.id))
                  ? (_openBlock(), _createBlock(_component_ion_badge, {
                      key: 9,
                      class: "bottom-left",
                      color: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('inCart')), 1)
                      ]),
                      _: 1
                    }))
                  : ($props.product.type == 'Gift')
                    ? (_openBlock(), _createBlock(_component_ion_badge, {
                        key: 10,
                        class: "bottom-left",
                        color: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('giftForYou')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
        ($props.product.coralGrade)
          ? (_openBlock(), _createBlock(_component_ion_badge, {
              key: 11,
              class: "top-right-badge"
            }, {
              default: _withCtx(() => [
                _createElementVNode("small", null, [
                  _createElementVNode("b", null, _toDisplayString($props.product.coralGrade), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "product-img rounded-img",
            src: $setup.addResizeUrlParams($props.product.photoLink, 300),
            onLoad: _cache[0] || (_cache[0] = ($event: any) => ($setup.imgLoaded = true))
          }, null, 40, _hoisted_3),
          _withDirectives(_createVNode(_component_ion_spinner, null, null, 512), [
            [_vShow, !$setup.imgLoaded]
          ])
        ])
      ]),
      ($props.hidePrice)
        ? (_openBlock(), _createBlock(_component_ion_card_header, {
            key: 0,
            class: "product-header",
            style: {"padding-bottom":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_subtitle, {
                color: "dark",
                class: "ion-text-center ion-text-nowrap"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.getLocalizedStr($props.product, 'title', 'titleEn')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_card_header, {
            key: 1,
            class: "product-header",
            style: {"padding-bottom":"4px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_subtitle, {
                color: "dark",
                class: "ion-text-center ion-text-nowrap"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.getLocalizedStr($props.product, 'title', 'titleEn')), 1)
                ]),
                _: 1
              }),
              (!$props.hideMerchantName)
                ? (_openBlock(), _createBlock(_component_ion_card_subtitle, {
                    key: 0,
                    class: "ion-text-center subtitle"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.product.merchantName), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($props.product.auction)
                ? (_openBlock(), _createBlock(_component_ion_card_subtitle, {
                    key: 1,
                    class: "ion-text-center special-offer"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" HK$" + _toDisplayString(Number($props.product.auction.currentBid || $props.product.auction.startingPrice).toLocaleString()), 1),
                      _hoisted_4,
                      ($setup.getAuctionTimeDiffText($props.product.auction))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.getAuctionTimeDiffText($props.product.auction)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : ($props.product.type == 'Gift')
                  ? (_openBlock(), _createBlock(_component_ion_card_subtitle, {
                      key: 2,
                      class: "ion-text-center price"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("s", null, "HK$" + _toDisplayString(Number($props.product.price).toLocaleString()), 1),
                        _createTextVNode(),
                        _createVNode(_component_ion_text, { color: "success" }, {
                          default: _withCtx(() => [
                            _createTextVNode("HK$0")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : ($props.product.sellingPrice != $props.product.price)
                    ? (_openBlock(), _createBlock(_component_ion_card_subtitle, {
                        key: 3,
                        class: "ion-text-center special-offer"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("s", null, "HK$" + _toDisplayString(Number($props.product.price).toLocaleString()), 1),
                          _createTextVNode(" HK$" + _toDisplayString(Number($props.product.sellingPrice).toLocaleString()), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_card_subtitle, {
                        key: 4,
                        class: "ion-text-center price"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" HK$" + _toDisplayString(Number($props.product.sellingPrice).toLocaleString()), 1)
                        ]),
                        _: 1
                      }))
            ]),
            _: 1
          })),
      ($props.product.ownerName && $props.product.ownerName != $setup.settings.defaultProductOwnerName)
        ? (_openBlock(), _createBlock(_component_ion_chip, {
            key: 2,
            style: {"height":"26px","font-size":"12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_avatar, null, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: $props.product.ownerProfilePic || 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg'
                  }, null, 8, _hoisted_6)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.product.ownerName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ($props.showActionButtons)
        ? (_openBlock(), _createBlock(_component_ion_buttons, {
            key: 3,
            class: "product-actions"
          }, {
            default: _withCtx(() => [
              ($props.product.inStock)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.addProductToCart($props.product)), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.cartOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($props.userLoggedIn && $props.product.likedByUser)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($props.product, 'remove')), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.heart,
                        color: "danger"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($props.userLoggedIn && !$props.product.likedByUser)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 2,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($props.product, 'add')), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.heartOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClick", "onTouchend", "disabled"]))
}